import {derived} from 'svelte/store';
import {BehaviorSubject, Subject, combineLatest} from 'rxjs';
import {skipUntil, switchMap, startWith} from 'rxjs/operators';
import {timeUtil} from '@/helper/time';
import {buyCrypto} from '@/api/buy-crypto';
import {klineApi} from '@/api/kline';
import {browser$} from '@/streams/browser';
import {indexKlineScale$} from '@/streams/config/index-products';
import {fixLink$, lang$} from '@/store/lang';
import {MULTILANG_LINKS} from './const';

export const fiats$ = new BehaviorSubject([]);
export const buyCryptoSupportCurrencies$ = new BehaviorSubject([]);
export const supportPayWays$ = new BehaviorSubject([]);
export const channelWeight$ = new BehaviorSubject([]);
export const transferoCPFCountries$ = new BehaviorSubject([]);
export const klineDataQuery$ = new Subject();
export const indexPriceData$ = new BehaviorSubject({date: [], value: []});
export const loading$ = new BehaviorSubject(false);
export const limitErrorMsg$ = new BehaviorSubject({isError: false, limit: {min: '1', max: '100000000'}});
export const currentCoin$ = new BehaviorSubject('');

export const fixArticleLink$ = derived(
  [lang$, fixLink$],
  ([lang, fixLink], set) =>
    set((o, type) => {
      if (MULTILANG_LINKS[o]) {
        return MULTILANG_LINKS[o][lang] || o;
      }
      return fixLink(o, type);
    }),
  (o) => o
);

browser$.subscribe(() => getSupportedConfig());

async function getSupportedConfig() {
  const {data} = await buyCrypto.getSupportedConfig();
  if (data) {
    const {fiats, currencies, supportPayWays, channelWeights, transferoCPFCountries = []} = data;
    fiats$.next(fiats.filter((o) => o.available === 1));
    buyCryptoSupportCurrencies$.next(currencies.filter((o) => o.available === 1));
    supportPayWays$.next(supportPayWays.filter((o) => o.available === 1));
    channelWeight$.next(channelWeights.filter((o) => o.enable));
    transferoCPFCountries$.next(transferoCPFCountries);
  }
}

combineLatest([indexKlineScale$, klineDataQuery$, browser$])
  .pipe(
    skipUntil(browser$),
    switchMap(([scaleConfig, query]) => loadIndexPrice(scaleConfig, query)),
    startWith({total: 0, rows: []})
  )
  .subscribe((o) => indexPriceData$.next(o));

async function loadIndexPrice(items, query) {
  const item = items.find((item) => item.symbol === query.symbol);
  loading$.next(true);
  const {data} = await klineApi.buyCryptoTrend(query, item);
  if (data) {
    loading$.next(false);
    return convertData(data, query);
  }
  loading$.next(false);
  return [];
}

function convertData(data, query) {
  const isDay = query.resolution === '1440';
  const date = [];
  const value = [];
  data.items.forEach((o) => {
    date.push(isDay ? timeUtil.formatMonthDay(o.time) : timeUtil.formatHourMin(o.time));
    value.push(o.close);
  });
  return {date, value};
}
